(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/constants.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/constants.js');

const names = {
  REFERENCE: 'reference',
  ADDRESS1: 'address1',
  ZIP: 'zip',
  CITY: 'city',
  TERMS_AND_CONDITIONS: 'terms_and_conditions',
  CONTACT: 'contact',
  COUNTRYID: 'countryId',
  COMPANY_NAME: 'companyName',
  ORGANIZATION_NUMBER: 'organizationNumber',
  CONTACT_PERSON: 'contactPerson',
  EMAIL: 'eMail',
  PHONE: 'phone',
  CELL_PHONE: 'cellPhone'
};

const TEXTS = {
  ADRESS: {
    LABEL: 'Adress',
    MAX: 35,
    MAX_ERROR: 'Fältet får inte innehålla mer än 35 tecken',
    REQUIRED_ERROR: 'Du måste ange en adress'
  },
  ZIPCODE: {
    LABEL: 'Postnummer',
    REQUIRED_ERROR: 'Du måste ange postnummer',
    ONLY_DIGITS: 'Fältet får bara innehålla siffror.',
    MAX: 'Fältet får inte innehålla mer än 5 siffror',
    MIN: 'Fältet får inte innehålla färre än 5 siffror'
  },
  CITY: {
    LABEL: 'Postort',
    MAX: 25,
    MAX_ERROR: 'Fältet får inte innehålla mer än 25 tecken',
    REQUIRED_ERROR: 'Du måste ange postort'
  },
  TERMS_AND_CONDITIONS: {
    LABEL: 'Jag accepterar villkoren',
    LINK_TEXT: 'Allmänna villkor för Lotter för företag'
  },
  CONTACT_PERSON: {
    LABEL: 'Kontaktperson',
    MAX: 40,
    MAX_ERROR: 'Fältet får inte innehålla mer än 40 tecken',
    REQUIRED_ERROR: 'Du måste ange en kontaktperson'
  },
  COMPANY_NAME: {
    LABEL: 'Företagsnamn',
    MAX: 35,
    MAX_ERROR: 'Fältet får inte innehålla mer än 35 tecken',
    REQUIRED_ERROR: 'Du måste ange en text'
  },
  ORGANIZATION_NUMBER: {
    LABEL: 'Organisationsnummer',
    MAX: 20,
    MIN: 10,
    MAX_ERROR: 'Fältet får inte innehålla mer än 20 tecken',
    MIN_ERROR: 'Fältet får inte färre än 10 tecken',
    REQUIRED_ERROR: 'Du måste ange ett organisationsnummer'
  },
  PHONE_NUMBER: {
    LABEL: 'Telefon',
    REQUIRED_ERROR: 'Du måste ange ett telefonnummer'
  },
  CELL_PHONE_NUMBER: {
    LABEL: 'Mobilnummer',
    REQUIRED_ERROR: 'Du måste ange ett mobilnummer'
  }
};

const countries = [
  { name: 'Sverige', id: 35 },
  { name: 'Norge', id: 31 },
  { name: 'Finland', id: 14 },
  { name: 'Danmark', id: 11 },
  { name: 'Australien', id: 2 },
  { name: 'Belgien', id: 3 },
  { name: 'Bulgarien', id: 4 },
  { name: 'Brazilien', id: 5 },
  { name: 'Cypern', id: 8 },
  { name: 'Estland', id: 12 },
  { name: 'Frankrike', id: 15 },
  { name: 'Indien', id: 21 },
  { name: 'Irland', id: 19 },
  { name: 'Island', id: 22 },
  { name: 'Israel', id: 20 },
  { name: 'Italien', id: 23 },
  { name: 'Japan', id: 24 },
  { name: 'Kanada', id: 6 },
  { name: 'Kroatien', id: 17 },
  { name: 'Lettland', id: 27 },
  { name: 'Liechtenstein', id: 25 },
  { name: 'Litauen', id: 26 },
  { name: 'Mexico', id: 29 },
  { name: 'Monaco', id: 28 },
  { name: 'Nederländerna', id: 30 },
  { name: 'Polen', id: 32 },
  { name: 'Portugal', id: 33 },
  { name: 'Rumänien', id: 34 },
  { name: 'Schweiz', id: 7 },
  { name: 'Singapore', id: 36 },
  { name: 'Slovakien', id: 38 },
  { name: 'Slovenien', id: 37 },
  { name: 'Spanien', id: 13 },
  { name: 'Storbritannien', id: 16 },
  { name: 'Sydafrika', id: 41 },
  { name: 'Tjeckien', id: 9 },
  { name: 'Tyskland', id: 10 },
  { name: 'Ungern ', id: 18 },
  { name: 'Uruguay', id: 40 },
  { name: 'USA', id: 39 },
  { name: 'Österrike', id: 1 }
];

svs.ticket_partner.sharedComponents.input.constants = {
  names,
  TEXTS,
  countries
};


 })(window);